module.exports = __webpack_public_path__ + "static/img/Tech_05.03a24145.png";